import React from "react";
// import ContributeContainer from "../../components/contributeContainer/ContributeContainer";
import { RiWomenLine } from "react-icons/ri";
import { FaHandshake } from "react-icons/fa";
import { FaTrophy } from "react-icons/fa";
import { IoIosPeople } from "react-icons/io";
// import dummy from "../../assets/images/dummy.jpg";
import ImpactCounter from "../../components/ImpactCounter";
import "./Impact.css";
function Impact() {
  const impactContent = [
    {
      id: 0,
      iconName: RiWomenLine,
      counter: "20,136",
      desc: "Number of women impacted",
    },
    {
      id: 1,
      iconName: FaHandshake,
      counter: "60",
      desc: "Orders and Market connects created",
    },
    {
      id: 2,
      iconName: FaTrophy,
      counter: "1514",
      desc: "Exhibitions organised",
    },
    { id: 3, iconName: IoIosPeople, counter: "270", desc: "Number of clients" },
  ];
  return (
    <div
      className="background"
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        paddingRight: "40px",
        // backgroundColor: "red",/
        color: "white",
        fontSize: "25px",
        fontFamily: "revert",
        flex: 1,
        height: "85vh",
        // justifyContent: "center",
        alignItems: "center",
        zIndex: 2,
      }}
    >
      <div className="subBackGround"></div>
      <div
        style={{
          // backgroundImage: `url(${dummy})`,
          height: "100vh",
          marginTop: "-70px",
          fontSize: "50px",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      ></div>
      {/* <div style={{ zIndex: 1, height: "100%", width: "100%" }}>
        <img src={dummy} alt="" />
      </div> */}
      {impactContent.map((item, _) => {
        return (
          <div
            key={item.id}
            style={{
              display: "flex",
              zIndex: 2,
              justifyContent: "center",
            }}
          >
            <ImpactCounter
              icon={<item.iconName />}
              iconStyle={{ fontSize: "60px", color: "rgb(4, 112, 105)" }}
              counter={item?.counter}
              desc={item?.desc}
            />
          </div>
        );
      })}
    </div>
  );
}

export default Impact;
